import type { NSmallGlobalEntities } from '@app/types/SmallGlobalEntities';

/**
 * Утилита удаляет все разделители между цифрами телефона.
 * Пример: +7-999-999-99-99 -> 79999999999.
 * @param phone Телефон, например, клиента или пользователя
 */

// TODO: заменить извлечением только цифр (RegExp)
export const deletePhoneDividers: (
  phone: NSmallGlobalEntities.Phone
) => string = (phone: NSmallGlobalEntities.Phone) => {
  if (phone) {
    const phoneWithoutHyphens = phone?.replaceAll('-', '');
    const phoneWithoutRoundBrackets = phoneWithoutHyphens
      ?.replace('(', '')
      .replace(')', '');
    const onlyPhoneDigits = phoneWithoutRoundBrackets?.replace('+', '');

    return onlyPhoneDigits.replaceAll('_', '').replaceAll(' ', '');
  } else {
    return '';
  }
};
